import PropTypes from 'prop-types'
import React from 'react'
import FairsList from '../FairsList'

export default function FairFilterModal({
  active, selectedId, onClose, onChange,
}) {
  return (
    <div className={`modal ${active ? 'active' : ''}`}>
      <a type="button" className="modal-overlay" aria-label="Fechar" onClick={onClose} />
      <div className="modal-container">
        <div className="modal-header">
          <a type="button" className="btn btn-clear float-right" onClick={onClose} />
          <div className="modal-title h5">Selecionar feira</div>
        </div>
        <div className="modal-body">
          {active && <FairsList selectedId={selectedId} onChange={onChange} />}
        </div>
      </div>
    </div>
  )
}

FairFilterModal.propTypes = {
  active: PropTypes.bool.isRequired,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
}

FairFilterModal.defaultProps = {
  selectedId: '',
}
